import angular from 'angular';

import apiDirectives from './api.directive';
import autoScout24Component from './autoscout24/autoscout24.component';
import datApiComponent from './dat/dat-api.component';
import juhuAutoComponent from './juhu-auto/juhu-auto.component';
import linkApiComponent from './link-entry/link-api.component';
import mobileSellerComponent from './mobile-seller/mobile-seller.component';
import schwackeApiComponent from './schwacke/schwacke-api.component';
import stellantisWebsiteComponent from './stellantis-website/stellantis-website.component';

import Routes from './api.routes';

export default angular.module('autoboard.apiComponents', [
  apiDirectives,
  autoScout24Component,
  datApiComponent,
  juhuAutoComponent,
  linkApiComponent,
  mobileSellerComponent,
  schwackeApiComponent,
  stellantisWebsiteComponent,
])
  .config(Routes)
  .name;
